import React, { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_INTERCOM_INFO } from "../../api/graphql/users";
import Spinner from "../Spinner";
import Intercom from "@intercom/messenger-js-sdk";

const IntercomComponent = ({
  data: userData,
}: {
  data: { email: string; name: string };
}) => {
  const { data, loading } = useQuery(GET_INTERCOM_INFO);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (data && userData && !isInitialized.current) {
      Intercom({
        app_id: "jwyd1703",
        intercom_user_jwt: data.getUserIntercomJWT,
        name: userData?.name,
        email: userData?.email,
        hide_default_launcher: true,
      });
      isInitialized.current = true;
    }
  }, [data, userData]);

  if (loading) return <Spinner />;

  return null;
};

export default IntercomComponent;
